package com.eladfinish.bible.contest.screens.settings.ui.dialogs

import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.extensions.formatString
import com.eladfinish.bible.contest.font_format
import com.eladfinish.bible.contest.font_preview
import com.eladfinish.bible.contest.pasuk_example
import com.eladfinish.bible.contest.screens.settings.SettingsAction
import com.eladfinish.bible.contest.screens.settings.SettingsState
import com.eladfinish.bible.contest.ui.common.toFontResource
import com.eladfinish.bible.contest.ui.components.dialogs.BasicDialogWithTitle
import com.eladfinish.bible.contest.ui.components.dialogs.DialogNegativeButtonInColumn
import dev.icerock.moko.resources.compose.fontFamilyResource
import dev.icerock.moko.resources.compose.localized
import dev.icerock.moko.resources.desc.desc
import dev.icerock.moko.resources.format

@Composable
internal fun SettingsDialogs(
    dialogState: SettingsState.DialogState,
    onAction: (SettingsAction) -> Unit,
) {
    when (dialogState) {
        SettingsState.DialogState.None -> Unit

        is SettingsState.DialogState.RandomApproachExplanation -> {
            BasicDialogWithTitle(
                onDismiss = {
                    onAction(SettingsAction.HideDialog)
                },
                title = "איך זה משפיע על ההגרלה?",
                content = {
                    Text(
                        modifier = Modifier
                            .padding(top = 12.dp, bottom = 24.dp)
                            .padding(horizontal = 12.dp),
                        text = dialogState.content,
                    )
                    DialogNegativeButtonInColumn(onClick = { onAction(SettingsAction.HideDialog) })
                }
            )
        }

        is SettingsState.DialogState.FontPreview -> {
            val fontName = dialogState.selectedFont
            val title = SharedRes.strings.font_format.format(fontName.removeSuffix(".ttf"))
            val fontResource = fontName.toFontResource()
            val fontFamily = fontFamilyResource(fontResource)

            BasicDialogWithTitle(
                onDismiss = {
                    onAction(SettingsAction.ApplyFontChange(selectedFont = fontName))
                },
                title = title.localized(),
                fontFamily = fontFamily,
                content = {
                    Text(
                        modifier = Modifier
                            .padding(top = 12.dp, bottom = 24.dp)
                            .padding(horizontal = 12.dp),
                        text = "%s\n\n%s".formatString(
                            SharedRes.strings.font_preview.desc().localized(),
                            SharedRes.strings.pasuk_example.desc().localized(),
                        ),
                        style = TextStyle(
                            fontSize = 20.sp,
                            color = Color.Black,
                            fontFamily = fontFamily,
                        )
                    )
                    DialogNegativeButtonInColumn(
                        onClick = {
                            onAction(SettingsAction.ApplyFontChange(selectedFont = fontName))
                        }
                    )
                }
            )
        }
    }
}
